import { AuthenticateWithRedirectCallback } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";

/**
 * ClawInstall admin OAuth (SSO) return route.
 *
 * Clerk's `<SignIn routing="path" path="/admin/login">` sends the social-login
 * round-trip back to `/admin/login/sso-callback`; this route completes the
 * handshake so Google sign-in lands the admin inside the ClawInstall admin
 * console instead of dead-ending on a missing callback route. Like the admin
 * login itself it lives under `admin_/` so it stays public (un-nested from the
 * role-gated admin layout).
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/admin_/login/sso-callback")({
  component: ClawInstallAdminSSOCallback,
});

export function ClawInstallAdminSSOCallback() {
  return <AuthenticateWithRedirectCallback />;
}
